
document.addEventListener('DOMContentLoaded', () => {
  const formContainer = document.querySelector('.form-container');

  const observer = new MutationObserver((mutationsList, observer) => {
  const form = document.querySelector('form-embed');

if (form) {
  observer.disconnect();
  const shadow = form.shadowRoot;

  const sheet = new CSSStyleSheet();
  sheet.insertRule(`
    ._textHeading_2aowh_35 {
      color:#000000 !important; 
      font-family:'PostGrotesk-Medium' !important;
    }`);

  sheet.insertRule(`
    button {
      background-color:#da1b27 !important; 
      color:white;
      align-self:center!important;
      min-width:9rem!important;
      border-radius:4px!important;
      font-family:'PostGrotesk-Medium' !important;
    }`);

    sheet.insertRule(`
    label, p {
      color:#000000!important;
      font-family:'PostGrotesk-Medium' !important;
    }`);

  shadow.adoptedStyleSheets.push(sheet);
  formContainer.classList.add('loaded');


}
    
});

observer.observe(document.body, { childList: true, subtree: true });
  
});



